module.exports = __webpack_public_path__ + "static/media/ni.fd764d41.svg";